import "./button.scss";
import Loading from "../../assets/images/loading.svg";

export default function Button({ text, icon, onClick, active = false, className = "", loading, width }) {
  return (
    <button className={`button ${active ? "active" : ""} ${className}`} onClick={onClick} style={{width: width}}>
      {icon && <img src={icon} alt="icon" width={20} className="buttonIcon" />}
      {loading ? <img src={Loading} alt="loading" width={20} /> : text}
    </button>
  );
}
